import { ArrowLeft } from 'lucide-react';
import React from 'react';
import { Button } from '../../../components/ui/button';
import styles from './EditSegment.module.css';

interface EditSegmentHeaderProps {
  onBack: () => void;
  onSave: () => void;
  isSaveDisabled: boolean;
  isSaving: boolean;
}

export const EditSegmentHeader: React.FC<EditSegmentHeaderProps> = ({
  onBack,
  onSave,
  isSaveDisabled,
  isSaving,
}) => {
  return (
    <header className={styles.header}>
      <button type="button" onClick={onBack}>
        <ArrowLeft />
        Back to Segments
      </button>
      <Button onClick={onSave} disabled={isSaveDisabled}>
        {isSaving ? 'Saving...' : 'Save Segment'}
      </Button>
    </header>
  );
};
